import React from 'react';
import { useSelector } from 'react-redux';

import queryString from 'query-string';
import { withRouter } from 'react-router-dom';
import { apiGet, apiPost } from 'services';

export const SlackIntegration = ({ location }) => {
    const [slack, setSlack] = React.useState(null);
    const { user } = useSelector(state => state.user);
    const [mode, setMode] = React.useState('connected'); //loading/connected/request/accepted/denied
    const [canConnect, setCanConnect] = React.useState(false);

    React.useEffect(() => {
        apiGet('slack/check', user.guid, result => {
            if (result.connected) {
                setMode('connected');
            } else {
                const values = queryString.parse(location.search);
                setSlack({ userId: values.user_id, workspaceId: values.workspace_id });
                setMode('request');
            }
        });
    }, []);

    React.useEffect(() => {
        if (!slack || !user) {
            return;
        }

        setCanConnect(true);
    }, [slack, user]);

    const allow = () => {
        // api call to link the user up
        apiPost('slack/link', slack, user.guid, () => {
            setMode('accepted');
        });
    };

    const deny = () => {
        setMode('denied');
    };

    const renderContent = () => {
        switch (mode) {
            case 'loading':
                return (
                    <div>
                        <section className="content-header text-center mb10">
                            <h1>Checking Connection</h1>
                        </section>
                        <div className="flex flex-center flex-column">
                            <div className="flex flex-center">
                                <img src="/dist/img/slack-logo.svg" alt="Slack" loading="lazy" className="mr10" />
                                <h3>Checking your Slack Connection to Prism</h3>
                            </div>
                        </div>
                    </div>
                );
            case 'request':
                return (
                    <div>
                        <section className="content-header text-center mb10">
                            <h1>Grant Permission</h1>
                        </section>
                        <div className="flex flex-center flex-column">
                            <div>
                                <div className="flex flex-center mb10">
                                    <img src="/dist/img/slack-logo.svg" alt="Slack" loading="lazy" className="mr10" />
                                    <h3>Slack is requesting permission to Connect to Prism</h3>
                                </div>

                                <div className="text-center">
                                    <button className="btn btn-default mr10" onClick={deny}>
                                        Deny
                                    </button>
                                    <button className="btn btn-success" onClick={allow} disabled={!canConnect}>
                                        Allow
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                );
            case 'connected':
                return (
                    <div>
                        <section className="content-header text-center mb10">
                            <h1>Already Connected</h1>
                        </section>
                        <div className="flex flex-center flex-column">
                            <div className="flex flex-center mb10">
                                <img src="/dist/img/slack-logo.svg" alt="Slack" loading="lazy" className="mr10" />
                                <h3>Slack is Connected to Prism</h3>
                            </div>

                            <div>
                                <a className="btn btn-success" href="/">
                                    Home
                                </a>
                            </div>
                        </div>
                    </div>
                );
            case 'accepted':
                return (
                    <div>
                        <section className="content-header text-center mb10">
                            <h1>Connected</h1>
                        </section>
                        <div className="flex flex-center flex-column mb10">
                            <div className="flex flex-center">
                                <img src="/dist/img/slack-logo.svg" alt="Slack" loading="lazy" className="mr10" />
                                <h3>Slack is Connected to Prism</h3>
                            </div>

                            <div>
                                <a className="btn btn-success" href="/">
                                    Home
                                </a>
                            </div>
                        </div>
                    </div>
                );
            case 'denied':
                return (
                    <div>
                        <section className="content-header text-center mb10">
                            <h1>Connection Denied</h1>
                        </section>
                        <div className="flex flex-center flex-column">
                            <div className="flex flex-center mb10">
                                <img src="/dist/img/slack-logo.svg" alt="Slack" loading="lazy" className="mr10" />
                                <h3>Slack is Not Connected to Prism</h3>
                            </div>

                            <div>
                                <a className="btn btn-success" href="/">
                                    Home
                                </a>
                            </div>
                        </div>
                    </div>
                );
        }
    };

    return <div>{renderContent()}</div>;
};

export default withRouter(SlackIntegration);
